<template>
  <BoardView :pagination="pagination" :title="$t('title')" :total="total">
    <div slot="button">
      <Row>
        <Column :md="6">
          <Btn @click="doShowExport = true">
            {{ $t('exportSheet') }}
          </Btn>
        </Column>
        <Column :md="6">
          <Btn @click="doShowImport = true">
            {{ $t('importSheet') }}
          </Btn>
        </Column>
      </Row>
      <LaptopExportModal
        :doShow.sync="doShowExport"
        :isExporting.sync="isExporting" />
      <LaptopImportModal
        :doShow.sync="doShowImport"
        :isImporting.sync="isImporting" />
    </div>
    <BoardTable
      :hasResults="!!total"
      :isFetching="isFetching"
      :pagination="pagination">
      <Row>
        <Column v-for="laptop in results" :key="laptop.id" :xl="6">
          <RecordLaptop :laptop="laptop" />
        </Column>
      </Row>
    </BoardTable>
    <router-view />
  </BoardView>
</template>

<script>
import { actions, getters } from '@utils'
import { prop, propEq } from 'rambda'
import LaptopExportModal from './components/LaptopExportModal'
import LaptopImportModal from './components/LaptopImportModal'
import RecordLaptop from '@components/RecordLaptop'
import Table from '@mixins/Table'
import { objOfPath } from '@utils/objects'
import { pluckId } from '@utils/collections'

export default {
  mixins: [Table],
  components: {
    LaptopExportModal,
    LaptopImportModal,
    RecordLaptop,
  },
  data() {
    const { improper, missing } = this.$store.getters.laptopsQueriesOptions

    return {
      doShowExport: false,
      isExporting: false,

      doShowImport: false,
      isImporting: false,

      paginationOptions: {
        name: 'laptop',
        service: 'laptop',
        searchIn: [
          'name',
          'asin',
        ],
        tabs: [
          {
            label: this.$t('all'),
            value: null,
          },
          {
            label: this.$t('missingSpecs'),
            append: () => ({
              $or: this.laptopsQueries
                .filter(propEq('type', 'missing'))
                .flatMap(prop('query')),
            }),
          },
          {
            label: this.$t('improperSpecs'),
            append: () => ({
              $or: this.laptopsQueries
                .filter(propEq('type', 'improper'))
                .flatMap(prop('query')),
            }),
          },
        ],
        tabsIndexes: [0],
        filters: [
          {
            label: 'Missing',
            type: 'select',
            append: this.getLaptopQueryByKey,
            options: missing,
          },
          {
            label: 'Improper',
            type: 'select',
            append: this.getLaptopQueryByKey,
            options: improper,
          },
          {
            label: this.$t('cpu'),
            type: 'text',
            append: objOfPath(['cpu', '$ilike']),
          },
          {
            label: this.$t('gpu'),
            type: 'text',
            append: objOfPath(['gpu', '$ilike']),
          },
        ],
      },
    }
  },
  computed: getters('laptopsQueries'),
  methods: {
    getLaptopQueryByKey(key) {
      if (!key) return null

      return {
        $or: (this.laptopsQueries
          .find(laptopQuery => laptopQuery.key === key) || {})
          .query,
      }
    },
    ...actions(
      'FETCH_MISSING_FILE',
    ),
  },
  watch: {
    async results(laptops) {
      if (!laptops.length) return

      const fileIds = pluckId('imageFileId', laptops)

      await this.LOAD(() =>
        this.FETCH_MISSING_FILE(fileIds))
    },
  },
}
</script>

<style lang="scss">
</style>

<i18n>
{
  "en": {
    "title": "Laptop",
    "all": "All",
    "cpu": "CPU",
    "gpu": "GPU",
    "missingSpecs": "Missing specs",
    "improperSpecs": "Improper specs",
    "exportSheet": "Export sheet",
    "importSheet": "Import sheet"
  }
}
</i18n>
